import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-visualizar-classificacao-fase1',
  templateUrl: './visualizar-classificacao-fase1.component.html',
  styleUrls: ['./visualizar-classificacao-fase1.component.scss']
})
export class VisualizarClassificacaoFase1Component {
  classificacaoFase1: any[] = [];
  tiposProvaFase1: string[] = [];
  tipoProvaSelecionadoFase1: string = '';
  notasPorTipoFase1: { [key: string]: any[] } = {};
  colunasPorTipoFase1: { [key: string]: string[] } = {};
  comissoesInfoFase1: { [key: string]: { nome: string, matricula?: string } } = {};
  datepipe: DatePipe = new DatePipe('pt-BR');

  constructor(
    public dialogRef: MatDialogRef<VisualizarClassificacaoFase1Component>,
    @Inject(MAT_DIALOG_DATA) public data: { classificacao: any[], resumoNotas: any[] }
  ) {
    this.processarDados();
  }

  private processarDados(): void {
    this.classificacaoFase1 = this.data.classificacao.map((item: any, index: number) => ({
      classificacao: index + 1,
      inscricaoId: item.inscricaoId,
      nome: item.nome,
      nomeSocial: item.nomeSocial,
      nascimento: this.formatarData(item.nascimento),
      mediaFinal: item.mediaFinal,
      PCD: item.PCD,
      eliminado: item.estaEliminado
    }));

    this.processarResumoNotas(this.data.resumoNotas);
  }

  private processarResumoNotas(data: any[]): void {
    const tiposProva = [...new Set(data.map(item => item.tipoProva))].sort();
    const notasPorTipo: { [key: string]: any[] } = {};
    const colunasPorTipo: { [key: string]: string[] } = {};
    const comissoesInfo: { [key: string]: { nome: string, matricula?: string } } = {};

    data.forEach(item => {
      if (item.nomeComissaoJulgadora && item.comissaoJulgadoraId) {
        comissoesInfo[item.comissaoJulgadoraId] = {
          nome: item.nomeComissaoJulgadora,
          matricula: item.matriculaComissaoJulgadora
        };
      }
    });

    tiposProva.forEach(tipo => {
      const notasTipo = data.filter(item => item.tipoProva === tipo);
      const comissaoIds = [...new Set(notasTipo.map(item => String(item.comissaoJulgadoraId)))].sort();
      colunasPorTipo[tipo] = ['inscricaoId', 'nome', ...comissaoIds];

      const candidatos = [...new Set(notasTipo.map(item => item.inscricaoId))];
      notasPorTipo[tipo] = candidatos.map(inscricaoId => {
        const candidato = notasTipo.find(n => n.inscricaoId === inscricaoId);
        const linha: any = { inscricaoId, nome: candidato?.nome, nomeSocial: candidato?.nomeSocial };
        comissaoIds.forEach(comissaoId => {
          const nota = notasTipo.find(n => n.inscricaoId === inscricaoId && String(n.comissaoJulgadoraId) === comissaoId);
          linha[comissaoId] = nota?.nota !== undefined ? nota.nota : '-';
        });
        return linha;
      });
    });

    this.tiposProvaFase1 = tiposProva;
    this.notasPorTipoFase1 = notasPorTipo;
    this.colunasPorTipoFase1 = colunasPorTipo;
    this.comissoesInfoFase1 = comissoesInfo;
  }

  public selecionarTipoProvaFase1(tipo: string): void {
    this.tipoProvaSelecionadoFase1 = this.tipoProvaSelecionadoFase1 === tipo ? '' : tipo;
  }

  public getComissaoNomeFase1(comissaoId: string): string {
    return this.comissoesInfoFase1[comissaoId]?.nome || comissaoId;
  }

  public getComissaoMatriculaFase1(comissaoId: string): string | undefined {
    return this.comissoesInfoFase1[comissaoId]?.matricula;
  }

  private formatarData(dataStr: string): string {
    const data = new Date(dataStr);
    return this.datepipe.transform(data, 'dd/MM/yyyy') ?? '';
  }

  fechar(): void {
    this.dialogRef.close();
  }
}
